import { Chip, SxProps, Theme } from '@mui/material';

/**
 * Gray `TERMINADO` chip shown when a pair's Kalshi market has settled
 * (`settledOnKalshi`) on the live `market_lifecycle_v2` feed — the mirror of
 * the opener's TERMINADO pill on the positions + unwinder pages. Renders
 * nothing when the pair has not settled, so call sites can drop it in
 * unconditionally. Display-only; independent of `eventFinished`.
 */
export function TerminadoChip({
  settledOnKalshi,
  sx
}: {
  settledOnKalshi?: boolean;
  sx?: SxProps<Theme>;
}) {
  if (!settledOnKalshi) return null;
  return (
    <Chip
      label="TERMINADO"
      size="small"
      sx={{
        height: 16,
        flexShrink: 0,
        fontSize: '0.6rem',
        fontWeight: 700,
        letterSpacing: '0.03em',
        backgroundColor: '#555',
        color: '#fff',
        '& .MuiChip-label': { px: 0.6 },
        ...sx
      }}
    />
  );
}
